import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from '../shared/services/setting.service';
//import { ReCaptchaV3Service } from 'ngx-captcha';
import { EmailService, ISimpleEmail } from '../shared/services/email.service';
import { ModalController } from '@ionic/angular';
import { ModalDisplayComponent } from '../shared/components/modal-display/modal-display.component';
import { LoaderService } from '../shared/services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { TranslationService } from '../shared/services/translation.service';
import { ApiControllerService } from '../shared/services/api-controller.service';

@Component({
    selector: 'data-privacy-contact-page',
    templateUrl: './data-privacy-contact-page.component.html',
    styleUrls: ['./data-privacy-contact-page.component.scss'],
    standalone: false
})
export class DataPrivacyContactPageComponent implements OnInit {
  language: string;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  postalCode: string = '';
  subject: string = '';
  details: string = '';

  //siteKey: string = "6LfaOD4oAAAAANFRDBwxpXGxyuHZqG5FiEmU-GKJ"; // localhost  invalidEmail: boolean = false;
  invalidPostalcode: boolean = false;
  ipAddress: string = '';

  get logoUrl() {
    return 'assets/imgs/logo/shopachat.png';
  }

  constructor(
    //public translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private settingService: SettingService,
    //private reCaptchaV3Service: ReCaptchaV3Service,
    private emailService: EmailService,
    private loader: LoaderService,
    private modalCtrl: ModalController,
    private snackBar: MatSnackBar,
    private http: HttpClient,
    private translationService: TranslationService,
    private apiController: ApiControllerService
  ) {}

  async ngOnInit() {
    console.log("test");
    this.language = this.route.snapshot.params['language'];
    if (!this.language || (this.language !== 'en' && this.language !== 'fr')) {
      this.router.navigate(['/data-privacy-contact/']);
      return;
    }

    if (!this.settingService.configuration) {
      await this.settingService.initializeApp();
    }

    setTimeout(() => {
      this.translationService.get$("PrivacyContact.DataPrivacy").subscribe(translated => {
        this.subject = translated;
      });
    }, 500);

    // Fetch user's IP address
    /* this.http.get<{ ip: string }>('https://api.ipify.org?format=json')
      .subscribe(
        response => {
          this.ipAddress = response.ip;
          console.log('Fetched IP address:', this.ipAddress);  // ?? Log IP address
        },
        error => {
          console.error('Could not fetch IP address', error);
          this.ipAddress = 'Unavailable';
        }
      ); */

      this.apiController.get<{ ip: string }>('https://api.ipify.org?format=json')
        .subscribe(
          response => {
            this.ipAddress = response.ip;
            console.log('Fetched IP address:', this.ipAddress);  // ?? Log IP address
          },
          error => {
            console.error('Could not fetch IP address', error);
            this.ipAddress = 'Unavailable';
          }
        );
  }

  resetForm() {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.postalCode = '';
    this.details = '';
  }

  async submit() {
    const loader = await this.loader.create();
    await loader.present();

    const appName = this.settingService.configuration?.name || 'ShopAchat';

    let toClient: ISimpleEmail = {
      From: appName,
      Subject: `${appName} - ${this.subject}`,
      Email: this.email,
      Content: `
        <div style='width: 600px; margin: auto; padding: 20px; border: #80808080 1px solid; margin-top: 3em;'>
          <img src=https://shopachat.ca/assets/imgs/logo/shopachat.png style='width: 100px; margin: auto; display: flex;'>
          <br><br>
          <p style='color: black;'>${this.translationService.translate("PrivacyContact.Hello")} ${this.firstName} ${this.lastName},</p>
          <br><br>
          <p style='color: black;'>${this.translationService.translate("PrivacyContact.ThankYou")}</p>
          <br><br>
          <p style='color: black; margin-bottom: 0px;'>${this.translationService.translate("PrivacyContact.YourMessage")}:</p>
          <p style='color: gray; margin-top: 0px; margin-left: 10px;'>${this.details}</p>
          <br><br><br>
          <p style='color: #ccc; font-size: 0.75em; margin-top: 28px; margin-bottom: 0px;'>${this.translationService.translate("PrivacyContact.ThisMessageIsAutomated")}</p>
        </div>`
    };

    this.emailService.send(toClient).subscribe((success) => {
      if (!success) {
        loader.dismiss();
        this.translationService.get$("PrivacyContact.InvalidEmail").subscribe(translated => {
          this.snackBar.open(translated, this.translationService.translate("General.Close"));
        });
      } else {
        let toShopAchat: ISimpleEmail = {
          From: `${this.firstName} ${this.lastName}`,
          Subject: `${appName} - ${this.subject}`,
          Email: "Privacy@shopachat.ca",
          Content: `
            <div style='width: 600px; margin: auto; padding: 20px; border: #80808080 1px solid; margin-top: 3em;'>
              <p style='color: black;'>${this.translationService.translate("PrivacyContact.FirstName")}: ${this.firstName}</p>
              <br>
              <p style='color: black;'>${this.translationService.translate("PrivacyContact.LastName")}: ${this.lastName}</p>
              <br>
              <p style='color: black;'>${this.translationService.translate("PrivacyContact.Email")}: ${this.email}</p>
              <br>
              <p style='color: black;'>${this.translationService.translate("PrivacyContact.PostalCode")}: ${this.postalCode}</p>
              <br>
              <p style='color: black;'>IP Address: ${this.ipAddress}</p>
              <br>
              <p style='color: black; margin-bottom: 0px;'>${this.translationService.translate("PrivacyContact.Details")}:</p>
              <p style='color: gray; margin-top: 0px; margin-left: 10px;'>${this.details}</p>
            </div>`
        };

        // ?? Log email content
        console.log('Email to ShopAchat:', toShopAchat.Content);

        this.emailService.send(toShopAchat).subscribe(() => {
          loader.dismiss();
          this.translationService.get$("PrivacyContact.FormSubmittedSuccessfully").subscribe(translated => {
            this.snackBar.open(
              translated,
              this.translationService.translate("General.Close"),
              { duration: 6000 }
            );
          });
          this.resetForm();
        });
      }
    }); 
  }

  displayPolicies() {
    this.settingService.getSAPolicies(this.translationService.getLanguage()).subscribe(async terms => {
      const requestModal = await this.modalCtrl.create({
        component: ModalDisplayComponent,
        componentProps: {
          title: "General.Policies",
          content: terms
        }
      });
      await requestModal.present();
    });
  }

  getPolicyPageUrl(): string {
    const language = 'en';  // or fetch dynamically if needed
    const tree = this.router.createUrlTree(['/data-privacy-contact', language]);
    return this.router.serializeUrl(tree);
  }
}
